import React, { useMemo } from "react";
import PT from "prop-types";
import moment from "moment";
import { ORDERS_NS as ns } from "@/i18n/ns";

const TaskTimers = (props) => {
  const beforeAccept = useMemo(() => {
    const accept = moment(props.acceptDeadLine);
    if (accept.isSameOrBefore(props.now)) {
      return null;
    }
    return props.now.to(accept, true);
  }, [props.now, props.acceptDeadLine]);
  const beforeStart = useMemo(() => {
    const start = moment(props.startDate);
    if (start.isSameOrBefore(props.now)) {
      return null;
    }
    return props.now.to(start);
  }, [props.accepted, props.now, props.startDate]);
  const beforeEnd = useMemo(() => {
    const end = moment(props.endDate);
    if (moment(props.startDate).isSameOrBefore(props.now)) {
      return props.now.to(end);
    }
  }, [props.accepted, props.now, props.endDate, props.startDate]);
  const beforePay = useMemo(() => {
    if (!props.isPayWaiting || !props.payDeadLine) {
      return null;
    }
    return props.now.to(moment(props.payDeadLine), true);
  }, [props.payDeadLine, props.isPayWaiting, props.now]);
  const beforeDispute = useMemo(() => {
    if (!props.isDisputeAllowed) {
      return null;
    }
    return props.now.to(moment(props.disputeDeadLine), true);
  }, [props.isDisputeAllowed, props.now, props.disputeDeadLine]);
  return (
    <div
      css={`
        margin-bottom: 5px;
      `}
    >
      {beforePay && (
        <div>
          {props.t(`${ns}:timers.pay`)} - {beforePay}
        </div>
      )}
      {beforeDispute && (
        <div>
          {props.t(`${ns}:timers.dispute`)} {beforeDispute}
        </div>
      )}
      {props.pending && beforeAccept && (
        <div>
          {props.t(`${ns}:timers.accept`)} - {beforeAccept}
        </div>
      )}
      {(props.accepted || props.isPaid) && beforeStart && (
        <div>
          {props.t(`${ns}:timers.start`)} {beforeStart}
        </div>
      )}
      {(props.accepted || props.isPaid) && beforeEnd && (
        <div>
          {props.t(`${ns}:timers.end`)} {beforeEnd}
        </div>
      )}
    </div>
  );
};
TaskTimers.propTypes = {
  pending: PT.bool.isRequired,
  accepted: PT.bool.isRequired,
  acceptDeadLine: PT.string,
  isPayWaiting: PT.bool.isRequired,
  payDeadLine: PT.string,
  endDate: PT.string.isRequired,
  startDate: PT.string.isRequired,
  isSafe: PT.bool.isRequired,
  isPaid: PT.bool.isRequired,
  isDisputeAllowed: PT.bool.isRequired,
  disputeDeadLine: PT.string,
  now: PT.any.isRequired,

  t: PT.func.isRequired,
};

export default TaskTimers;
